import { Route, Routes } from 'react-router-dom';

import { WelcomeSplash } from 'src/features/welcome/WelcomeSplash';
import { AppProvider, ProtectedAppShell } from 'src/providers/app';
import { AppRoutes } from 'src/routes';

const App = () => {
  return (
    <AppProvider>
      <Routes>
        <Route path="/welcome" element={<WelcomeSplash />} />
        <Route
          path="/*"
          element={
            <ProtectedAppShell>
              <AppRoutes />
            </ProtectedAppShell>
          }
        />
      </Routes>
    </AppProvider>
  );
};

// eslint-disable-next-line no-restricted-syntax
export default App;
